import { render, staticRenderFns } from "./ClientPutList.vue?vue&type=template&id=2c5c24ae"
import script from "./ClientPutList.vue?vue&type=script&lang=js"
export * from "./ClientPutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports